import configuration from '../config.js';

export type ApiClient = ReturnType<typeof createApiClient>;

const handleResponse = (response: Response) => {
  if (!response.ok) {
    throw new Error(`API ${response.status} ${response.statusText}`);
  }
  return response.json();
};

export function createApiClient(token: string) {
  const base = configuration['backend_host'];
  const authHeader: Record<string, string> = token ? { Authorization: `Bearer ${token}` } : {};

  return {
    get: (path: string) => fetch(`${base}${path}`, { headers: authHeader }).then(handleResponse),
    post: (path: string, body: unknown) =>
      fetch(`${base}${path}`, {
        method: 'POST',
        headers: { ...authHeader, 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      }).then(handleResponse),
    put: (path: string, body: unknown) =>
      fetch(`${base}${path}`, {
        method: 'PUT',
        headers: { ...authHeader, 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      }).then(handleResponse),
    delete: (path: string) =>
      fetch(`${base}${path}`, { method: 'DELETE', headers: authHeader }).then(handleResponse),
  };
}
